import script from "./TransitionSlide.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransitionSlide.vue?vue&type=script&setup=true&lang=ts"

import "./TransitionSlide.vue?vue&type=style&index=0&id=4622c124&scoped=true&lang=css"

import exportComponent from "/var/www/braintreewellbeing.org/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4622c124"]])

export default __exports__